import React, { createContext, ReactElement, useState, Dispatch, SetStateAction, useEffect } from "react";
import { cachearContexto } from "../../helpers/cachearContexto";
import MotivoCancelamentoTicketService from "../../services/MotivoCancelamentoTicketService";
import { MotivoCancelamentoTicketType } from "../../types/CancelamentoTicketType";

interface CancelamentoTicketContextProps {
  listaMotivoCancelamentoTicket: MotivoCancelamentoTicketType[];
  setListaMotivoCancelamentoTicket: Dispatch<SetStateAction<MotivoCancelamentoTicketType[]>>
  handleAtualizarCancelamentoTicket: (motivoCancelamento:MotivoCancelamentoTicketType, idMotivoCancelamentoTicket?:number) => void;
  handleRemoveCancelamentoTicket: (idMotivoCancelamentoTicket:number) => void;
}

export const CancelamentoTicketContext = createContext({} as CancelamentoTicketContextProps);

export function CancelamentoTicketProvider({ children }: { children: ReactElement }) {
  const [listaMotivoCancelamentoTicket, setListaMotivoCancelamentoTicket] = useState<MotivoCancelamentoTicketType[]>([] as MotivoCancelamentoTicketType[]); 

  const handleAtualizarCancelamentoTicket = (motivoCancelamento:MotivoCancelamentoTicketType, idMotivoCancelamentoTicket?:number) => {
    if(idMotivoCancelamentoTicket){
      setListaMotivoCancelamentoTicket((current) => {
        return ordenar(current.map((item) => {
           if(item?.id_motivo_cancelamento_ticket === idMotivoCancelamentoTicket){
             return motivoCancelamento;
           }
           return item;
        }))
      })
    }else{
      setListaMotivoCancelamentoTicket((current) => ordenar([motivoCancelamento, ...current]));
    }
  }
  
  const ordenar = (motivos:MotivoCancelamentoTicketType[]) => {
    return motivos.sort((a, b) => {return a.descricao < b.descricao ? 1 : -1})
  } 
  const handleRemoveCancelamentoTicket = (idMotivoCancelamentoTicket:number) => {
    setListaMotivoCancelamentoTicket((current) => current.filter((item) => item.id_motivo_cancelamento_ticket !== idMotivoCancelamentoTicket));
  }

  return (
      <CancelamentoTicketContext.Provider
        value={{
          listaMotivoCancelamentoTicket,
          setListaMotivoCancelamentoTicket,
          handleAtualizarCancelamentoTicket,
          handleRemoveCancelamentoTicket
        }}
      >
          {children}
      </CancelamentoTicketContext.Provider>
  );
}
